import { useTranslation } from 'react-i18next';
import BlockTitle from '../../BlockTitle';
import {
  Button,
  Text,
  Grid,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import Recipients from './Recipients';
import Subject from './Subject';
import Message from './Message';
import { useOneTimeReportStore } from '../store';
import { useState } from 'react';
import ReportPreviewModal from '../../ReportPreviewModal';
import i18next from 'i18next';

export const ReportNotification = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();

  return (
    <>
      <BlockTitle
        content={t('reportCommon.titles.notification')}
        paddingTop="68px"
      />
      <Text pt="6px" pb="12px" color={colorStyle.color.primary}>
        {t('reportCommon.titles.notificationSub')}
      </Text>
      <Grid templateColumns="130px max-content" rowGap="18px">
        <Recipients />
        <Subject />
        <Message />
        <div></div>
        <ReportPreview />
      </Grid>
    </>
  );
};

const ReportPreview = () => {
  const { t } = useTranslation();
  const [isPreviewOpen, previewOpenToggle] = useState(false);

  const name = useOneTimeReportStore((store) => store.generalSetting.name);
  const sections = useOneTimeReportStore(
    (store) => store.reportContent.sections
  );
  const message = useOneTimeReportStore((store) => store.notification.message);

  return (
    <>
      <Button width="max-content" onClick={() => previewOpenToggle(true)}>
        {t('reportCommon.buttons.preview')}
      </Button>
      {/* preview modal */}
      <ReportPreviewModal
        isPreviewOpen={isPreviewOpen}
        onClose={previewOpenToggle}
        data={{
          name,
          template: t('dashboard.tabs.threatDetection'),
          sections: Object.keys(sections)
            .filter((value, index) => {
              return Object.values(sections)[index] === true;
            })
            .map((item) => {
              return t(`reportCommon.content.${item}`);
            })
            .join(i18next.language === 'ja' ? '、' : ', '),
          reportType: t('reportCommon.preview.oneTimeReport'),
          message,
        }}
      />
    </>
  );
};
